/**
 * CR038: Community Signal Diagnostics - Admin Console
 * CR072: Renamed from Forum Deals to Community Signal Diagnostics
 * Candidate detection + scoring diagnostics for community sources
 */

import { AdminLayout } from "@/components/admin/AdminLayout";
import { CommunitySignalsUnifiedPanel } from "@/components/admin/CommunitySignalsUnifiedPanel";

export default function ForumDeals() {
  return (
    <AdminLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Community Signal Diagnostics</h1>
          <p className="text-muted-foreground">
            Candidate detection + scoring diagnostics for community sources
          </p>
        </div>

        {/* CR038: Full CommunitySignalsUnifiedPanel functionality */}
        <CommunitySignalsUnifiedPanel />
      </div>
    </AdminLayout>
  );
}
